import React, { useState, useEffect } from 'react'
import Section from '../../atoms/Section/Section'
import setHtmlElementOverflowHidden from '../../../utils/setHtmlElementOverflowHidden'
import NativeReviewForm from './NativeReviewForm.tsx'
import StarRatings from '../../StarRatings/StarRatings'
import Text from '../../atoms/Text/Text'
import Button from '../../atoms/Button/Button'

const zeroReviewsWrapperMargin = `mb-[210px] [@media(min-width:366px)]:mb-[164px] [@media(min-width:466px)]:mb-[100px] [@media(min-width:768px)]:mb-[64px]`
const introContainerCss =
  'p-[32px] flex flex-col mt-auto mx-[24px] mb-0 gap-[24px] bg-stone-100 text-white shadow-md rounded-[32px] w-full max-w-[888px] shadow-[0_0_8px_2px_rgb(0,0,0,0.03),0_16px_24px_rgb(0,0,0,0.1)] [@media(min-width:931px)]:flex-row [@media(min-width:931px)]:m-auto [@media(min-width:931px)]:p-[64px]'

export default function LeaveAReviewBanner({
  title,
  image,
  hasReviews = false
}) {
  const [showTypeform, setShowTypeform] = useState(false)
  useEffect(() => {
    setHtmlElementOverflowHidden(showTypeform)
  })

  const backgroundStyles = image
    ? {
        backgroundImage: `url('${image}')`,
        backgroundPosition: 'center'
      }
    : {}

  return (
    <div
      className={`wrapper ${
        hasReviews ? 'mb-[64px]' : zeroReviewsWrapperMargin
      }`}
    >
      <NativeReviewForm
        onClose={() => setShowTypeform(false)}
        isNativeReviewModalVisible={showTypeform}
        title={title}
      />
      <Section
        id="reviews"
        fluid
        size="large"
      >
        <div
          className="align-center relative flex justify-center bg-orange-25 bg-cover py-[36px] md:h-[534px] md:py-0"
          style={backgroundStyles}
        >
          <div className={`intro-container ${introContainerCss}`}>
            <div className="left-section w-auto md:w-[410px]">
              <div className="mobile mb-[24px] block md:hidden">
                <StarRatings
                  rating={5}
                  starRatedColor="#F1C249"
                  starSpacing="5px"
                  numberOfStars={5}
                  uniqueKey="leave-a-review-mobile"
                  starDimension="26px"
                />
              </div>
              <p className="font-Figtree text-[36px] font-[600] not-italic leading-10 text-gray-1100">
                We love hearing about your treatment experience
              </p>
              <div className="desktop mt-[24px] hidden md:block">
                <StarRatings
                  rating={5}
                  starRatedColor="#F1C249"
                  starSpacing="5px"
                  numberOfStars={5}
                  uniqueKey="leave-a-review-desktop"
                  starDimension="26px"
                />
              </div>
            </div>
            <div className="right-section flex-1">
              <Text
                style={{
                  marginBottom: '24px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: '#162941'
                }}
              >
                Help individuals and families seeking treatment by sharing your
                first-hand experience with this treatment provider.{' '}
                <a
                  className="link underline"
                  href="/review-guidelines/"
                >
                  Review Guidelines.
                </a>
              </Text>
              <div
                id="leave-a-review-button"
                className="flex h-[52px] min-w-full justify-between md:min-w-[172px]"
              >
                <Button
                  style={{
                    color: '#F8F9FB',
                    height: '100%',
                    padding: '8px 12px'
                  }}
                  id="LeaveAReviewTest"
                  onClick={() => setShowTypeform(true)}
                >
                  Leave a Review
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  )
}
